

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.BIB8xk4Q.js","_app/immutable/chunks/disclose-version.YH_UEx2V.js","_app/immutable/chunks/runtime.Pj7aJ0cC.js","_app/immutable/chunks/legacy.B4uDpR7U.js","_app/immutable/chunks/render.BERvbqyL.js","_app/immutable/chunks/svelte-head.De3oOjf5.js","_app/immutable/chunks/entry.CULZp9KJ.js","_app/immutable/chunks/index-client.DMtyxnIq.js","_app/immutable/chunks/index.CTT1hA0n.js"];
export const stylesheets = [];
export const fonts = [];
